module.exports = "\t<div class=\"container-outer-box\">\n\t\n\t\t<div class=\"container\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-lg-9 col-md-12\">\n\t\t\t\t\n\t\t\t\t\t<app-populartopic></app-populartopic>\t\t\t\t\t\n              <app-forum></app-forum>\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-lg-3 col-md-12\">\t\t\t\t\t\n\t\t\t\t  <app-right-sidebar2 [user]=userData></app-right-sidebar2>\n\t\t\t\t</div>\n\t\t\t</div>\t\n\t\t\n\t\t</div>\n\t</div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/landing/landing.component.html
// module id = ../../../../../src/app/home/landing/landing.component.html
// module chunks = common